import { Dialog, Grid, Stack, Typography } from '@mui/material'
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';
import { ToolContext } from '../../../../core/context/ToolContext';
// import { ProductPromoPage } from './personalization/PromoPage';
import CapGueImg from '../../../../assets/images/core/capgue.png'

export const Todo = ({open, industry_list, selected, onboard}) => {
	const { tool_state, promo_product_state, setup_training_state } = useContext(ToolContext)
	const { __SESSION, userId } = tool_state 
    const { templates } = promo_product_state
	const { trainingForm } = setup_training_state
    const [todoList, setTodoList] = useState([]);
	const [hasPromoPage, setHasPromoPage] = useState(true)
	// const [start, setStart] = useState(false)
    const history = useHistory()

    const selectedIndustries = industry_list.filter(f => 
        selected.data.some(item => item.id === f.id)
    )

    const product = [
        {name: 'Create Promo Page', description: 'Create a promo page with payment ready to share on social media.', url: `/campaign/promo?type=product&step=template`, walkthrough: 'productPromoPage', size: 4},
        {name: 'Record Calls', description: 'Record calls for tracking and review.', url: `/campaign/call-monitoring?type=record&method=create`, size: 4},
        {name: 'Setup Contact', description: 'Setup contact for marketing use.', url: `/setup/contacts?subft=product`, size: 4},
    ]
    const booking = [
        {name: 'Create Promo Page', description: 'Create a promo page with payment ready to share on social media.', url: `/campaign/promo/service/customization?step=1`, size: 4},
        {name: 'Record Calls', description: 'Record calls for tracking and review.', url: `/campaign/call-monitoring?type=record&method=create`, size: 4},
        {name: 'Setup Contact', description: 'Setup contact for marketing use.', url: `/setup/contacts?subft=booking`, size: 4},
    ]
    const bd_service = [
        {name: 'Create Promo Page', description: 'Create a promo page with payment ready to share on social media.', url: '', size: 4},
        {name: 'Record Calls', description: 'Record calls for tracking and review.', url: '', size: 4},
        {name: 'Setup Contact', description: 'Setup contact for marketing use.', url: '', size: 4},
    ]
    const training = [
        {name: 'Set-up your training', description: 'Setup your training for free or with Pay.', url: `/setup/training`, size: 3},
        {name: 'Record Calls', description: 'Record calls for tracking and review.', url: `/campaign/call-monitoring?type=record&method=create`, size: 3},
        {name: 'Setup Contact', description: 'Setup contact for marketing use.', url: `/setup/contacts?subft=training`, size: 3},
        {name: 'Create Poster', description: 'Create training Poster and post it in your social media account', url: `/campaign/training-poster/customize?id=NA==&step=content` , size: 3},
    ]

    const handlerFirstTask = (data) => {
		if (data.id === 1) {
			templates.set({...templates.data, preview: {toggled: true}})
			history.push(`/campaign/promo?type=product&step=template`)
		}else if (data.id === 2) {
			onboard.set(true)
			history.push(`/campaign/promo/service/customization?step=1`)
		}else if (data.id === 3) {
			history.push(`/bd/leads`)
		}else if (data.id === 4) {
			trainingForm.set({...trainingForm.data, open : true})
			history.push(`/setup/training`)
		}
		open.set(p => ({...p, todo : false}))
		console.log(data)
		return
        if (selectedIndustries.length > 1) {
            setTodoList(data.id === 1 ? product : data.id === 2 ? booking : data.id === 3 ? bd_service : training)
            // selected.set([])
        }
    }
    const handlerTodo = (data) => {
        if (data.name === 'Create Promo Page' && (!userId?.data || !hasPromoPage)) {
            onboard.set(true)
        }
        if (data?.walkthrough === 'productPromoPage') {
            templates.set({...templates.data, preview: {toggled: true}})
        }
		if (data.name === 'Set-up your training') {
			trainingForm.set({...trainingForm.data, open : true})
		}
        history.push(data.url)
        open.set({welcome: false, todo: false})
    }

    useEffect(() => {
        if (selectedIndustries.length === 1) {
            setTodoList(selected.data[0].id === 1 ? product : selected.data[0].id === 2 ? booking : selected.data[0].id === 3 ? bd_service : training)
        } else {
			setTodoList([])
		}
        // eslint-disable-next-line
    }, [selected])

	useEffect(() => {
		const readPromoPage = async () => {
			if (userId?.data) {
				const r = await rqx.get(`<<tool>>/${env()}/template/read`, {company_id: __SESSION.data.uaccess[0].company_id, user_id: userId.data, lastId: 0, limit: 100})
				if (r.length === 0) {
					setHasPromoPage(false)
				}
			}
		}
		readPromoPage();
	}, [])

    return (
		<>
			<Dialog open={open.data.todo} maxWidth="lg" fullWidth>
				<Stack gap={5} py={3} px={9}>
					<Stack direction="row" alignItems="center" justifyContent="center">
						<img src={CapGueImg} alt={CapGueImg} height={128} />
						{
							selectedIndustries.length > 1 ?
								<Typography fontSize="1.5rem" fontWeight={600}>
									What business would you like to do first?
								</Typography>
							:
								<Typography fontSize="1.5rem" fontWeight={600}>
									What would you like to do first?
								</Typography> 
						}
					</Stack>
					<Grid container spacing="14px">
						{
							selectedIndustries.map((v,k) => (
								<Grid item sm={6} sx={{cursor: 'pointer'}} key={k}>
									<Stack border="1px solid #B6B1B1ED" borderRadius="14px" p={2} gap="14px" height="100%"
										onClick={() => handlerFirstTask(v)}
										sx={{
											':hover': { bgcolor: "#E0EBD5" }
										}}
									>
										<Stack direction="row" justifyContent="space-between">
											<Typography fontSize="1.375rem" fontWeight={600}>{v.name}</Typography>   
											{v.icon} 
										</Stack>
										<Typography fontSize="0.875rem" color="#5B6167">{v.description}</Typography>
									</Stack>
								</Grid>
							))
						}
					</Grid>
				</Stack>
			</Dialog>
		</>
    )
}
